import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type {
    ReceivePaymentParams,
    ReceivePaymentForm,
    ReceivePayment,
    ReceivePaymentVo,
    ServiceSpecialVo
} from "@zhihaoscm/entity";
import { type CancelReceivePaymentForm, type ConfirmReceivePaymentForm } from "@zhihaoscm/entity";
import { convertObjectToFormData } from "@/utils/object";

export class ReceivePaymentService extends BaseService<
    ReceivePaymentVo,
    unknown,
    ReceivePaymentParams,
    ReceivePaymentForm
> {
    /**金额查询 */
    async getAmount(params: { productId?: string; productType?: number }): Promise<{
        paidAmount: number;
        pendingPaymentAmount: number;
        receivePaymentAmount: number;
    }> {
        const { data } = await this.service.get(`${this.path}/amount`, { params });
        return data;
    }

    /**根据订单id查询所有已支付的，并且有未开票金额的收款单 */
    async uninvoicedByOrderId(params: { orderId: string }): Promise<ReceivePayment> {
        const { data } = await this.service.get(`${this.path}/uninvoiced`, {
            params
        });
        return data;
    }

    /**新增收款 */
    async createPayment(params: ReceivePaymentForm): Promise<ReceivePayment> {
        const { data } = await this.service.post(`${this.path}`, params);
        return data;
    }

    /**修改收款 */
    async updatePayment(id: string, params: ReceivePaymentForm): Promise<ReceivePayment> {
        const { data } = await this.service.put(`${this.path}/${id}`, params);
        return data;
    }

    /**
     * 取消
     */
    public async cancel(params: CancelReceivePaymentForm) {
        const { data } = await this.service.put(`${this.path}/cancel`, convertObjectToFormData(params));
        return data;
    }

    /**
     * 撤回
     */
    public async revoke(params: CancelReceivePaymentForm) {
        // 当前撤回接口按 @RequestParam 读取参数；放入查询参数可避免 multipart 字段未被后端绑定。
        const { data } = await this.service.put(`${this.path}/revoke`, undefined, { params });
        return data;
    }

    /**
     * 确认收款
     */
    public async confirm(params: ConfirmReceivePaymentForm) {
        const { data } = await this.service.put(`${this.path}/confirm`, params);
        return data;
    }

    /**
     * 详情快照------用于补录订单审核
     */
    public async getSnapshotVo(id: string): Promise<ReceivePaymentVo> {
        const { data } = await this.service.get(`receive-payment-snapshot/vo/${id}`);
        return data;
    }

    /**
     * 删除收款
     */
    public async delete(id: string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }
}

export const receivePaymentService = new ReceivePaymentService("/admin/receive-payment", request.service);

/** 查询收款管理使用的订单专员候选，沿用旧 Vue 指派弹框的订单专员接口。 */
export async function loadReceivePaymentSpecials(keyword = ""): Promise<ServiceSpecialVo[]> {
    const { data } = await request.service.get<ServiceSpecialVo[]>("/admin/order/find/specials", {
        params: keyword.trim() ? { name: keyword.trim() } : undefined
    });
    return data || [];
}
